var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalContext } from "@/contexts";
import { IconButton, Link, Menu, Portal, useSlotRecipe, } from "@chakra-ui/react";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { getLinksForAnchor } from "@/components/utils";
export function HeaderMenu() {
    var recipe = useSlotRecipe({ key: "Dropdown" });
    var recipeProps = recipe.splitVariantProps({})[0];
    var styles = recipe(recipeProps);
    var properties = useContext(GlobalContext).properties;
    var anchors = ["About", "Back", "CreateProfile", "PostJob"];
    var anchorLinks = anchors
        .map(function (anchor) { return getLinksForAnchor(anchor, properties); })
        .filter(function (link) { return link !== undefined; });
    return (_jsxs(Menu.Root, { children: [_jsx(Menu.Trigger, __assign({ asChild: true, "aria-label": "Options", variant: "outline" }, { children: _jsx(IconButton, { children: _jsx(FontAwesomeIcon, { icon: faBars }) }) })), _jsx(Portal, { children: _jsx(Menu.Positioner, { children: _jsx(Menu.Content, __assign({ css: styles.menuContent }, { children: anchorLinks.map(function (anchor) { return (_jsx(Menu.Item, __assign({ asChild: true, value: anchor.text, css: styles.menuItemOption }, { children: _jsx(Link, __assign({ href: anchor.href, target: "_blank", rel: "noreferrer", variant: "menu" }, { children: anchor.text })) }), anchor.href)); }) })) }) })] }));
}
